export default "__VITE_ASSET__4cbbe457__"